import { addClass, removeClass } from "./functions";
/**
 * Slider
 */
class slider {
    _el                : HTMLElement;
    _mediaQuery        : any;
    _index             : number;
    _oldActiveIndex    : number;
    _prev              : HTMLButtonElement;
    _prevIdClassName   : string;
    _next              : HTMLButtonElement;
    _nextIdClassName   : string;
    _sliderInit        : boolean;
    _dotList           : HTMLUListElement;
    _dotListIdClassName: string;
    _dotItemClassName  : string;
    _activeClass       : string;
    _resizeTimeOut     : number;
    _nbChild           : number;

    constructor( el: HTMLElement, mediaQuery?: any ) {
        this._el                 = el;
        this._mediaQuery         = mediaQuery;
        this._index              = 0;
        this._oldActiveIndex     = 0;
        this._sliderInit         = false;
        this._resizeTimeOut      = 350;
        this._prevIdClassName    = 'slider-prev';
        this._nextIdClassName    = 'slider-next';
        this._activeClass        = 'active';
        this._dotListIdClassName = 'slider-dots-container';
        this._dotItemClassName   = 'slider-dot-item';
        this._nbChild            = 0;
    }

    init = () => {
        if(this._mediaQuery){
            if(this._mediaQuery.matches){
                this.run();
            }
        }else {
            this.run();
        }
        // Add window event listener for the resize
        this.windowEvent();
    }

    run = () => {
        if (!this._sliderInit) {  
            this._nbChild = this.numberChild();
            if(this._nbChild > 1){
                this.addPrevNextBtn();
                this.addDotsNav();
                this.addEvent();
            }
            this.updateSlider();
            this._sliderInit = true;
        }
        if(this._sliderInit){
            this.sliderHeight();
        }
    }

    nextSlide = () => {
        this._oldActiveIndex = this._index;
        if (this._index < this.indexMax()) {
            this._index++;
            return this.updateSlider();
        }
    }

    prevSlide = () => {
        this._oldActiveIndex = this._index;
        if (this._index > 0) {
            this._index--;
            return this.updateSlider();
        }
    }
    // Get height of active slide
    sliderHeight = () => {
        let currentItem = <HTMLElement>this._el.children.item(this._index);
        this._el.style.height = currentItem.offsetHeight + "px";
    }
    // Go to selected slide
    goTo = () => {
        let currentItem = <HTMLElement>this._el.children.item(this._index);
        
        addClass( {domElement: currentItem, classList: this._activeClass} );

        if(this._nbChild > 1){
            let currentDotItem = <HTMLLIElement>this._dotList.children.item(this._index);
            addClass( {domElement: currentDotItem, classList: this._activeClass} );
        }
        
    }

    updateSlider = () => {
        if(this._nbChild > 1){
            this.reset(this._oldActiveIndex);
            this.setBtns();
        }
        this.goTo();
        this.sliderHeight();
    }
    // Index max
    indexMax = () => {
        return this._nbChild - 1;
    }
    // Number of slide in slider
    numberChild = () => {
        return this._nbChild = this._el.childElementCount;
    }
    // Update prev and next button state
    setBtns = () => {
        const nextBtn = <HTMLButtonElement>this._next;
        const prevBtn = <HTMLButtonElement>this._prev;
            
            if (this._index === this.indexMax()) {
                nextBtn.disabled = true;
                prevBtn.disabled = false;
            } else if (this._index === 0) {
                nextBtn.disabled = false;
                prevBtn.disabled = true;
            } else {
                nextBtn.disabled = false;
                prevBtn.disabled = false;
            }
    }
    // Add Dots navigation
    addDotsNav = () => {

        this._dotList = <HTMLUListElement>document.createElement("ul");
        
        this._dotList.id        = this._dotListIdClassName;
        this._dotList.className = this._dotListIdClassName;
        
        for (let i: number = 0; i < this._nbChild; i++) {
            const dotItem = <HTMLLIElement>document.createElement("li");
            const dotBtn = <HTMLButtonElement>document.createElement("button");
            dotItem.className = this._dotItemClassName;
            dotBtn.setAttribute('data-index', `${i}`);
            dotBtn.append(`${i + 1}`)
            dotItem.appendChild(dotBtn);

            this._dotList.appendChild(dotItem);
        }
        // Add dots list after slider element
        this._el.after(this._dotList);

    }
    // Reset old slide
    reset = (index: number) => {

        let oldActiveItem = <HTMLElement>this._el.children.item(index);
        let oldActiveDotItem = <HTMLLIElement>this._dotList.children.item(index);
        
        removeClass( {domElement: oldActiveItem, classList: this._activeClass} );
        removeClass( {domElement: oldActiveDotItem, classList: this._activeClass} );
    }
    // Create prev and next buttons
    addPrevNextBtn = () => {
        
        // Create buttons
        let prev = <HTMLButtonElement>this._prev;
        let next = <HTMLButtonElement>this._next;

                
        prev           = document.createElement("button");
        prev.id        = this._prevIdClassName;
        prev.className = this._prevIdClassName;

        next           = document.createElement("button");
        next.id        = this._nextIdClassName;
        next.className = this._nextIdClassName;

        // Create svg
        const boxW : string = "24";
        const boxH : string = "24";
        const xmlns: string = "http://www.w3.org/2000/svg";

        let svg = <SVGElement>document.createElementNS(xmlns, "svg");
        svg.setAttributeNS(null, "width", boxW);
        svg.setAttributeNS(null, "height", boxH);
        svg.setAttributeNS(null, "viewBox", "0 0 " + boxW + " " + boxH);

        let path = <SVGPathElement>document.createElementNS(xmlns, "path");
        
        path.setAttributeNS(null, "d", "M15.78 11.28c.14.14.22.331.22.53v.38c-.002.198-.081.388-.22.53l-5.14 5.13c-.094.095-.222.148-.355.148-.133 0-.261-.053-.355-.148l-.71-.71c-.094-.092-.147-.218-.147-.35 0-.132.053-.258.147-.35L13.67 12 9.22 7.56c-.095-.094-.148-.222-.148-.355 0-.133.053-.261.148-.355l.71-.7c.094-.095.222-.148.355-.148.133 0 .261.053.355.148l5.14 5.13z");
        
        svg.appendChild(path);
        let svgNext = <SVGElement>svg.cloneNode(true);

        prev.appendChild(svg);
        next.appendChild(svgNext);
        this._prev = prev;
        this._next = next;
        // Add prev and next button before slider element
        this._el.parentElement.insertBefore(prev, this._el);
        this._el.parentElement.insertBefore(next, this._el);

    }
    // Window event listener
    windowEvent = () => {
        let timeoutId;
        // Avoid function being called twice on window resize
        window.addEventListener('resize', (e: Event) => {
            window.clearTimeout(timeoutId);
            timeoutId = window.setTimeout(() => {
                (this._mediaQuery) ? (this._mediaQuery.matches ? this.run() : this.destroy()) : this.run();
            }, this._resizeTimeOut);
        });        
    }
    // Attach click event and keyboard nav to buttons
    addEvent = () => {
        // Prev, Next click event
        this._prev.addEventListener('click', (e: MouseEvent) => {
          e.preventDefault();
          return this.prevSlide();
        })
        this._next.addEventListener('click', (e: MouseEvent) => {
          e.preventDefault();
          return this.nextSlide();
        })
        // Dots nav event
        this._dotList.addEventListener('click', (e: MouseEvent) => {
            e.preventDefault();
            const target = <HTMLButtonElement>e.target;
            const index: number = parseInt(target.dataset.index);

            if(index != this._index){
                this._oldActiveIndex = this._index;
                this._index = index;
                this.updateSlider();
            }
            
        })
        // Keyboard event
        this._el.parentElement.addEventListener('keydown', (e: KeyboardEvent) => {
            switch (e.key) {
                case 'ArrowLeft':
                // left
                this.prevSlide();
                break;
                case 'ArrowRight':
                // right
                this.nextSlide();
                break;
                default:
                return;
            }
            e.preventDefault();
        });
    }
    // Destroy slider
    destroy = () =>{

        if( this._sliderInit ){
            this._prev.remove();
            this._next.remove();
            this._dotList.remove();
            this._prev = null;
            this._next = null;
            this._sliderInit = false;
            this.reset(this._index);
            this._el.style.removeProperty('height');
        }
    }
}

export default slider;